import { NonceRequest } from 'react-native-google-pal';
export {
  AlertModalTypes,
  DailyHourlyForecastTileDetail,
  LiveControlsTestIDs,
  TWCTimeLogoIDs,
  VODControlsTestIDs,
  accountPageTestIDs,
  alertDetailsPageTestIDs,
  alertsModalPageTestIDs,
  alertsTestIDs,
  currentWeatherConditionsPageTestIDs,
  currentWeatherConditionsTestIDs,
  dailyDayForecastTileTestIDs,
  dailyDaypartForecastTestIDs,
  dailyWeatherConditionsTestIDs,
  dailyWeatherPageTestIDs,
  dvrPageTestIDs,
  fullscreenVODPageTestIDs,
  hourlyHourForecastTileTestIDs,
  hourlyWeatherForecastIDS,
  hourlyWeatherPageTestIDs,
  livePageTestIDs,
  loadingPageTestIDs,
  locationsIDs,
  lowerDisplayLineTestIDs,
  mapPageTestIDs,
  menuTestIDs,
  myWeatherPageTestIDs,
  onDemandPageTestIDs,
  onboardingTestIDs,
  pictureDetailedVODPageTestIDs,
  searchPageTestIDs,
  settingsMenuTestIDs,
  settingsPageTestIDs,
  showDetailsPageHeaderTestIDs,
} from './testIDs';

export { Screen, Theme, appHeight, appWidth, height, pixelRatio, width } from './Theme';
export {
  ADOBE_API_TOKEN_KEY,
  ALERT_HEADLINES_REFETCH_INTERVAL,
  CURRENT_LIVE_VIDEO_STREAM,
  DEVICE_ID_KEY,
  DSP_ACCESS_TOKEN_KEY,
  DSP_CLIENT_TOKEN_KEY,
  ENVIRONMENT,
  GRID_INVENTORY_REFETCH_INTERVAL,
  LIGHTNING_REFETCH_INTERVAL,
  MAP_TILE_INVENTORY_REFETCH_INTERVAL,
  STORAGE_APP_INSTALLED,
  USER_SETTINGS_KEY,
} from './misc';
export { apiConfig, updateApiConfig, updateApiKeyConfig } from './apiConfig';
export { ConfigGateway } from './ConfigGateway';
export { WithAxios } from './WithAxios';

export const getPalRequest = (type: 'EPG' | 'VOD' = 'EPG'): Partial<NonceRequest> => ({
  videoWidth: 1920,
  videoHeight: 1080,
  adWillAutoPlay: true,
  adWillPlayMuted: false,
  continuousPlayback: type === 'EPG',
});
